import React from 'react';

function MobileLoading() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
      <p className="text-gray-600 text-sm">Chargement de l'application...</p>
      <p className="text-gray-400 text-xs mt-2">Si le chargement persiste, vérifiez votre connexion</p>
    </div>
  );
}

export default MobileLoading;
